import { PhoneNumberUtil } from 'google-libphonenumber'

import { getCountryISO3 } from '@/utils/countries/getCountryISO3'
import { ExtractNumberInfosWithoutRegionCodeReturn } from '@/types'

const phoneUtil = PhoneNumberUtil.getInstance()

export const extractPhoneNumberInfosWithoutRegionCode = (
  phoneNumber: string,
): ExtractNumberInfosWithoutRegionCodeReturn => {
  try {
    //Analise the phone number in international format
    const parsedNumber = phoneUtil.parse(phoneNumber)

    // Get region code based on the number analyzed
    const regionCode = phoneUtil.getRegionCodeForNumber(parsedNumber)

    // Get iso 3 code of the country
    const iso3Code = getCountryISO3(regionCode)

    // Get DDI based on the parsed number.
    const ddi = parsedNumber.getCountryCode()?.toString()

    return {
      regionCode: regionCode ?? '',
      iso3Code: iso3Code ?? '',
      ddi: ddi ?? '',
    }
  } catch (error) {
    console.error(
      `Error on extract number infos without region for number ${phoneNumber}:`,
      error,
    )
    return {
      regionCode: '',
      iso3Code: '',
      ddi: '',
    }
  }
}
